export default __webpack_public_path__ + "static/media/storage_size_3.8e122974.png";